import React from "react"
import { Route, Routes as SwitchRoutes, useLocation } from "react-router-dom"
import Schuladmin from "./pages/Bookmanagement/Schuladmin"
import AuthenticatedArea from "./container/AuthenticatedArea"
import Trading from "./pages/Trading/Trading"
import StartRouter from "./pages/Start/StartRouter"
import { F_VERWALTUNG, F_TRADING, F_INDEX, F_METRICS } from "./constants/routes"
import UserProvider from "./context/UserProvider"
import BackdropProvider from "./context/BackdropProvider"
import Metrics from "./pages/Metrics/Metrics"

const App = () => {
  const location = useLocation()

  return (
    <BackdropProvider>
      <UserProvider>
        <SwitchRoutes location={location}>
          <Route path={F_INDEX} element={<StartRouter />} />

          <Route element={<AuthenticatedArea role="User" />}>
            <Route path={`${F_TRADING}/*`} element={<Trading />} />
          </Route>

          <Route element={<AuthenticatedArea role="School" />}>
            <Route path={`${F_VERWALTUNG}/*`} element={<Schuladmin />} />
          </Route>

          <Route element={<AuthenticatedArea role="Admin" />}>
            <Route path={`${F_METRICS}/*`} element={<Metrics />} />
          </Route>

          <Route path="*" element={<StartRouter />} />
        </SwitchRoutes>
      </UserProvider>
    </BackdropProvider>
  )
}

export default App
